import { createContext, useContext } from 'react'

import { validateContext } from 'shared/utils'

export const UserPoolSidePanelStateContext = createContext({})
export const UserPoolSidePanelActionsContext = createContext({})

const useUserPoolSidePanelState = () => validateContext(useContext(UserPoolSidePanelStateContext), {
  contextName: 'UserPoolSidePanelStateContext',
  providerName: 'UserPoolSidePanelProvider'
})

export const useUserPoolSidePanelActions = () => validateContext(useContext(UserPoolSidePanelActionsContext), {
  contextName: 'UserPoolSidePanelActionsContext',
  providerName: 'UserPoolSidePanelProvider'
})

export const useUserPoolSidePanel = () => {
  const state = useUserPoolSidePanelState()
  const actions = useUserPoolSidePanelActions()

  return {
    ...state,
    ...actions
  }
}
